/* Shared pure pricing boundary. No network and no price supplied by the buyer is authoritative. */
(function(scope){'use strict';
const VERSION='ef-checkout-20260912-v1';
const same=(a,b)=>a!=null&&b!=null&&String(a)===String(b);
const questions=c=>c.questions||(c.stepGroups||[]).flatMap(g=>g.steps||[]).flatMap(s=>(s.questions||[]).map(q=>({...q,label:q.label||q.title||s.title})));
const cents=x=>/^\d+(\.\d{1,2})?$/.test(String(x))?Math.round(Number(x)*100):NaN;
const unique=rows=>{const seen=new Set();return rows.filter(row=>{const k=JSON.stringify(row);if(seen.has(k))return false;seen.add(k);return true;});};
const normalized=new WeakMap();
function normalize(cfg){
 if(normalized.has(cfg))return normalized.get(cfg);
 const qs=questions(cfg),ids=new Set(qs.map(q=>String(q.id)));
 const groups=(cfg.mapGroups||[]).map(g=>({...g,maps:unique((g.maps||[]).map(m=>({id:String(m.id),price:String(m.price),status:m.status,selectors:(m.selectors||[]).map(s=>({question:String(s.question),id:s.id,value:s.value,type:s.type})),components:m.components||(m.products||[]).map(p=>({reference:p.name||p.id,quantity:Number(m.qty||1)}))})))}));
 // Legacy import contains zero-only placeholder groups for controls absent from the page.
 // Removing one is safe only when every map is zero, every component is the zero placeholder,
 // and no selector or declared question refers to a customer-visible control.
 const result={...cfg,questions:qs,mapGroups:groups.filter(g=>!((g.maps||[]).length>0&&g.maps.every(m=>cents(m.price)===0&&(m.components||[]).every(c=>same(c.reference,'000000')&&!c.sku)&&(m.selectors||[]).every(s=>!ids.has(String(s.question))))&&(g.questions||[]).every(q=>!ids.has(String(q)))))};
 normalized.set(cfg,result);return result;
}
function selected(q,value){return(q.selections||[]).find(s=>same(s.id,value));}
function resolveFirepit(input,answers){
 const cfg=normalize(input),qs=cfg.questions,errors=[],lines=[];
 if(!answers||typeof answers!=='object'||Array.isArray(answers))return{valid:false,cents:null,lines,errors:[{code:'INVALID_ANSWERS'}]};
 for(const q of qs)if(!selected(q,answers[q.id]))errors.push({code:'UNKNOWN_OR_MISSING_CHOICE',question:q.id});
 for(const key of Object.keys(answers))if(!qs.some(q=>same(q.id,key))&&!((cfg.baseAnswers||[]).some(a=>same(a.questionID,key)&&same(a.value,answers[key]))))errors.push({code:'UNKNOWN_QUESTION',question:key});
 for(const g of cfg.mapGroups){
  const matches=g.maps.filter(m=>(m.status==null||[1,'1','active'].includes(m.status))&&(g.questions||[]).every(id=>m.selectors.some(s=>same(s.question,id)))&&m.selectors.every(s=>{if(![undefined,'equal','equals','eq'].includes(s.type))return false;const q=qs.find(q=>same(q.id,s.question)),v=selected(q||{},answers[s.question]);return v&&[v.id,v.value,v.numericValue].filter(x=>x!=null&&x!=='').some(value=>same(s.value,value)||same(s.id,value));}));
  if(matches.length!==1){errors.push({code:matches.length?'AMBIGUOUS_COMBINATION':'UNPRICED_COMBINATION',group:g.id});continue;}
  const m=matches[0],amount=cents(m.price);if(!Number.isSafeInteger(amount)||amount<0){errors.push({code:'INVALID_PRICE',group:g.id});continue;}
  const components=(m.components||[]).map(c=>({...c,quantity:Number(c.quantity)}));if(components.some(c=>!Number.isSafeInteger(c.quantity)||c.quantity<1)){errors.push({code:'INVALID_COMPONENT_QUANTITY',group:g.id});continue;}
  if(cfg.sourceVerified&&amount>0&&(!components.length||components.some(c=>!c.sku))){errors.push({code:'MISSING_ORDER_SKU',group:g.id});continue;}
  lines.push({group:g.id,title:g.title||'Configuration',mapId:m.id,cents:amount,components});
 }
 const total=lines.reduce((a,l)=>a+l.cents,0);if(!Number.isSafeInteger(total)||total<=0)errors.push({code:'INVALID_TOTAL'});
 return{valid:errors.length===0,cents:errors.length?null:total,lines,errors};
}
function defaultAnswers(cfg){const out={};for(const a of cfg.baseAnswers||[]){const q=questions(cfg).find(q=>same(q.id,a.questionID));if(!q)continue;const s=q.selections.find(s=>same(s.id,a.value)||same(s.id,a.id)||s.label===a.label);if(s)out[q.id]=s.id;}return out;}
function firepitProperties(cfg,answers,result){const props={};for(const q of questions(cfg)){const s=selected(q,answers[q.id]);if(s)props[q.label||q.title||q.id]=s.label;}props._pricing_version=VERSION;props._configuration_components=JSON.stringify(result.lines.flatMap(l=>l.components));props._configuration_maps=JSON.stringify(result.lines.map(l=>l.mapId));return props;}
function priceLexington(model,width,finish,bracket,legacyBracketOmission=false){
 if(typeof width!=='number'||!Number.isFinite(width)||width<30)throw Error('INVALID_WIDTH');
 if(finish!=='Custom Color Match'&&!model.finishes.includes(finish))throw Error('INVALID_FINISH');
 const sizes=[...model.sizes].sort((a,b)=>a.w-b.w),largest=sizes.at(-1),cap=Math.min(120,largest.w+48);
 if(width>cap)throw Error('INVALID_WIDTH');const exact=sizes.find(s=>s.w===width),color=finish==='Custom Color Match';let price,pieces=1,custom=!exact||color;
 if(exact)price=color?exact.price:(exact.std||exact.price);
 else if(width<=largest.w)price=sizes.find(s=>s.w>=width).price+400;
 else{const n=Math.ceil((width-largest.w)/24),v=largest.price*(1+.65*n),base=Math.floor(v/50)*50;price=[base-1,base+49,base+99].sort((a,b)=>Math.abs(a-v)-Math.abs(b-v))[0];pieces=1+n;if(!['Black','Bronze'].includes(bracket)&&!(legacyBracketOmission&&bracket==null))throw Error('BRACKET_FINISH_REQUIRED');}
 if(color)price+=350;return{cents:price*100,pieces,custom,color};
}
scope.EF_SECURE_PRICING=Object.freeze({VERSION,questions,normalize,resolveFirepit,defaultAnswers,firepitProperties,priceLexington,cents});
})(typeof window==='undefined'?globalThis:window);

/* Stable checkout identity survives uncertain responses and reloads in this tab. */
(function(scope){'use strict';if(scope.EFPrepareCheckout)return;const memory=new Map();scope.EFPrepareCheckout=async function(payload){const props={...(payload.properties||{})};const oldId=props._config_id;delete props._config_id;const note=oldId?String(payload.customer_note||'').split(oldId).join('[configuration]'):String(payload.customer_note||'');const semantic=JSON.stringify({variant_id:String(payload.variant_id),quantity:payload.quantity,calculated_price:payload.calculated_price,configuration:payload.configuration,properties:props,customer_note:note,customer_email:payload.customer_email||'',color_photo:payload.color_photo||'',color_photo_name:payload.color_photo_name||''});const bytes=await crypto.subtle.digest('SHA-256',new TextEncoder().encode(semantic));const hash=Array.from(new Uint8Array(bytes)).map(v=>v.toString(16).padStart(2,'0')).join('');const key='ef-checkout-request:'+hash;let id=memory.get(key);try{id=id||sessionStorage.getItem(key);}catch(_){}if(!id){id='efc-'+crypto.randomUUID();memory.set(key,id);try{sessionStorage.setItem(key,id);}catch(_){}}payload.request_id=id;payload.properties={...props,_config_id:id};if(oldId)payload.customer_note=String(payload.customer_note||'').split(oldId).join(id);return payload;};})(window);

(function(){var E=window.EF_SECURE_PRICING;window.EF_FIREPIT_PRICING={questions:E.questions,resolve:E.resolveFirepit,payload:function(cfg,answers,quantity,context){var r=E.resolveFirepit(cfg,answers);if(!r.valid)throw new Error('Choose a supported configuration or contact us for a quote.');if(!Number.isSafeInteger(quantity)||quantity<1||quantity>99)throw new Error('Enter a whole quantity from 1 to 99.');var properties=E.firepitProperties(cfg,answers,r);properties._config_id=context.configId;return{configuration:{version:E.VERSION,family:'firepit',catalog:'draft',productId:document.querySelector('.ef-fpcfg').dataset.productId,answers:{...answers}},product_title:context.productTitle,variant_id:String(context.variantId),quantity:quantity,calculated_price:r.cents,properties:properties,customer_note:'Firepit configuration — '+Object.entries(properties).filter(function(x){return !x[0].startsWith('_');}).map(function(x){return x[0]+': '+x[1];}).join(' | ')}}};})();
/**
 * EF Firepit Configurator — Phase 1C (accordion cards)
 *
 * Matches v6 doors design: each step is a stacked card with header + selected
 * preview + collapsible options grid. Bottom: Base Price / Total / ATC /
 * Express Checkout.
 *
 * Reads window.EF_FIREPIT_CFG. Pricing = sum of matched mapGroup prices.
 * ATC: posts to ef-draft-order Worker for honored-price cart line.
 */
(function () {
  'use strict';

  const FMT_USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // ─────────── SVG icon library for options that lack WD thumbnails ───────────
  const SVG_FLAME = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2c1.5 4 5 5 5 9 0 3.5-3 6-5 6s-5-2.5-5-6 3.5-5 5-9z"/><path d="M12 11c.8 1.2 2 2 2 3.5 0 1.3-1 2.5-2 2.5s-2-1.2-2-2.5c0-1.5 1.2-2.3 2-3.5z" fill="currentColor" stroke="none" opacity="0.4"/></svg>`;
  const SVG_PROPANE = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="7" y="6" width="10" height="14" rx="2"/><path d="M10 6V4a2 2 0 0 1 4 0v2"/><line x1="9" y1="10" x2="15" y2="10"/></svg>`;
  const SVG_MATCH = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M6 21l12-12"/><path d="M16 11c1.5-1.5 3.5-1 5-3-2-1-3.5-.5-5 1L13 13l3 3 3-3"/><circle cx="6" cy="21" r="1.2" fill="currentColor"/></svg>`;
  const SVG_LIGHTNING = `<svg viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z"/></svg>`;
  const SVG_CHECK = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>`;
  const SVG_SKIP = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><circle cx="12" cy="12" r="9"/><line x1="8" y1="12" x2="16" y2="12"/></svg>`;
  const SVG_PLUG = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3v6M15 3v6M7 9h10v3a5 5 0 0 1-10 0V9zM12 17v4"/></svg>`;
  const SVG_BATTERY = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="7" width="18" height="10" rx="1.5"/><line x1="22" y1="10" x2="22" y2="14" stroke-width="3"/><path d="M10 10l-1.5 3h3L10 16"/></svg>`;
  const SVG_BUTTON = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="4" fill="currentColor" opacity="0.25"/><circle cx="12" cy="12" r="1.8" fill="currentColor"/></svg>`;
  const SVG_FLAME_SENSE = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M10 2c1.5 4 5 5 5 9 0 3.5-3 6-5 6s-5-2.5-5-6 3.5-5 5-9z"/><circle cx="18" cy="6" r="2" fill="currentColor"/><path d="M18 9v3M16 10l4 0" opacity="0.5"/></svg>`;
  const SVG_RULER = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="9" width="20" height="6" rx="1"/><line x1="6" y1="9" x2="6" y2="12"/><line x1="10" y1="9" x2="10" y2="13"/><line x1="14" y1="9" x2="14" y2="12"/><line x1="18" y1="9" x2="18" y2="13"/></svg>`;
  const SVG_PALETTE = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3a9 9 0 1 0 0 18c1.1 0 2-.9 2-2 0-.5-.2-1-.5-1.3-.4-.4-.5-.9-.5-1.3 0-1.1.9-2 2-2h2.4A4.6 4.6 0 0 0 21 9.8C21 6 17 3 12 3z"/><circle cx="7" cy="10" r="1.2" fill="currentColor"/><circle cx="9" cy="6" r="1.2" fill="currentColor"/><circle cx="14" cy="6" r="1.2" fill="currentColor"/><circle cx="17" cy="9" r="1.2" fill="currentColor"/></svg>`;

  // Match by label (lowercased). Falls through to WD CDN image when label not mapped.
  const ICON_MAP = {
    // Fuel
    'natural gas': SVG_FLAME,
    'propane': SVG_PROPANE,
    'lp': SVG_PROPANE,
    'liquid propane': SVG_PROPANE,
    // Ignition — Manual / match
    'manual ignition': SVG_MATCH,
    'manual': SVG_MATCH,
    'match lit': SVG_MATCH,
    // Ignition — Electronic / plug
    'fyrestarter ignition': SVG_LIGHTNING,
    'fyrestarter': SVG_LIGHTNING,
    'electronic ignition': SVG_LIGHTNING,
    'electronic - 110v plug and play': SVG_PLUG,
    'electronic 110v plug and play': SVG_PLUG,
    'plug and play': SVG_PLUG,
    // Ignition — Flame Sense variants
    'match lit with flame sense': SVG_FLAME_SENSE,
    'flame sense with push button': SVG_BUTTON,
    'electronic - low voltage ignition': SVG_BATTERY,
    'electronic low voltage ignition': SVG_BATTERY,
    'low voltage ignition': SVG_BATTERY,
    // Cover / skip
    'no thank you': SVG_SKIP,
    'no': SVG_SKIP,
    'yes': SVG_CHECK,
  };

  // ─────────── Description library — short caption shown under selected option ───────────
  const DESCRIPTION_MAP = {};

  function descriptionFor(label) {
    if (!label) return null;
    return DESCRIPTION_MAP[label.toLowerCase().trim()] || null;
  }

  // WD URL patterns that we want to OVERRIDE with our SVG (e.g. their "No Thank You" branded logo)
  function shouldOverrideImg(url, label) {
    if (!url) return false;
    if (/NoThankYou|no-thank-you/i.test(url)) return true;
    return false;
  }

  function optionImageHtml(sel) {
    const key = (sel.label || '').toLowerCase().trim();
    let svg = ICON_MAP[key];
    // Size detection — e.g. '48"', '60', '72"', 'XL', 'Small' (pure-number → ruler)
    if (!svg && /^\d+(\.\d+)?\s*["'″]?$/.test(key)) {
      svg = SVG_RULER;
    }
    if (svg) {
      return `<span class="ef-fpcfg__optimg-svg">${svg}</span>`;
    }
    if (sel.img && !/woodlanddirect\.com/i.test(sel.img) && !shouldOverrideImg(sel.img, sel.label)) {
      return `<img src="${sel.img}" alt="${sel.label}" loading="lazy" onerror="this.parentNode.classList.add('is-empty');this.remove();">`;
    }
    // No usable image and no known SVG: leave empty (CSS shows the cream circle)
    return '';
  }

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function el(tag, attrs, html) {
    const e = document.createElement(tag);
    if (attrs) Object.entries(attrs).forEach(([k, v]) => {
      if (k === 'class') e.className = v;
      else if (k === 'dataset') Object.assign(e.dataset, v);
      else if (v === true) e.setAttribute(k, '');
      else if (v != null && v !== false) e.setAttribute(k, v);
    });
    if (html != null) e.innerHTML = html;
    return e;
  }

  function init() {
    const root = $('.ef-fpcfg');
    if (!root) return;
    const cfg = window.EF_FIREPIT_CFG;
    if (!cfg) { root.textContent = 'Configuration is temporarily unavailable. Please contact us for help.'; return; }

    const engine = window.EF_FIREPIT_PRICING;
    if (!engine) { root.textContent = 'Configuration is temporarily unavailable. Please contact us for help.'; return; }
    const steps = (cfg.stepGroups || []).flatMap(g => g.steps || []).flatMap(s => (s.questions || []).map(q => ({...s, title: q.label || q.title || s.title, questions: [q]})));
    if (!steps.length) { console.warn('[ef-cfg-firepits] no steps'); return; }

    root.appendChild(el('h2', {class:'ef-fpcfg__title'}, 'Configure your fire table'));
    const selections = {};
    const userPicked = new Set();
    // Normalize baseAnswers: some WD products (e.g. Carson Size) store baseAnswer.value
    // as something other than selection.id (e.g. "48" vs id "10005"). We want
    // selections{} to hold selection.id so visual "is-selected" check works, then
    // pricing match uses flexible id/value comparison below.
    (cfg.baseAnswers || []).forEach(a => {
      let resolved = a.value;
      const step = (steps || []).find(s => (s.questions || []).some(q => q.id === a.questionID));
      if (step) {
        const q = step.questions[0];
        const bestSel = (q.selections || []).find(sel =>
          sel.id === a.value || sel.id === a.id || sel.label === a.label
        );
        if (bestSel) resolved = bestSel.id;
      }
      selections[a.questionID] = resolved;
    });

    // Map selector matches current selection by either id OR value (handles WD's
    // mixed schema where Size uses value="48" but id="10005").
    function selectorMatches(sel, currentVal) {
      if (currentVal == null) return false;
      return sel.value === currentVal || sel.id === currentVal;
    }

    let busy = false;
    const storageKey = 'ef-firepit:' + root.dataset.productId + ':' + (cfg.version || 'legacy-exact-20260911');
    let sessionDesignRestored = false;
    try { const saved = JSON.parse(sessionStorage.getItem(storageKey)); if (saved && typeof saved === 'object') { Object.assign(selections, saved); sessionDesignRestored = true; } } catch (_) {}
    let configId = 'fp-' + (globalThis.crypto?.randomUUID?.() || Date.now());
    // Saved designs contain choices only; pricing remains the existing renderer's responsibility.
    const savedDesignKey = 'ef-firepit-design:' + root.dataset.productId + ':' + (cfg.version || 'legacy');
    let savedDesign = null;
    try { savedDesign = JSON.parse(localStorage.getItem(savedDesignKey)); if (savedDesign?.selections && !sessionDesignRestored) { steps.forEach(step => { const q=step.questions[0], value=savedDesign.selections[q.id]; if(q.selections.some(o=>o.id===value)) selections[q.id]=value; }); } } catch (_) {}
    root.addEventListener('ef-firepit-save', () => { try { localStorage.setItem(savedDesignKey, JSON.stringify({selections, quantity:Number(qty.value),savedAt:new Date().toISOString()})); root.dispatchEvent(new CustomEvent('ef-firepit-saved',{detail:{success:true}})); } catch (_) { root.dispatchEvent(new CustomEvent('ef-firepit-saved',{detail:{success:false}})); } });
    let openStep = 0;

    // Build per-step accordion cards
    const cards = steps.map((s, i) => {
      const q = s.questions[0];
      const card = el('section', { class: 'ef-fpcfg__card', dataset: { step: i, count: (q.selections || []).length } });

      // Header (number + title)
      card.appendChild(el('header', { class: 'ef-fpcfg__cardhead' }, `
        <span class="ef-fpcfg__cardnum">${i + 1}</span>
        <span class="ef-fpcfg__cardtitle">${s.title}</span>
      `));

      // Selected preview button
      const sel = el('button', { type: 'button', class: 'ef-fpcfg__cardselected', 'aria-expanded': 'false' });
      card.appendChild(sel);

      // Options grid container
      const optsWrap = el('div', { class: 'ef-fpcfg__cardopts' });
      const optsGrid = el('div', { class: 'ef-fpcfg__optsgrid' });
      optsWrap.appendChild(optsGrid);
      card.appendChild(optsWrap);

      return card;
    });

    cards.forEach(c => root.appendChild(c));

    // Pricing summary
    const pricing = el('div', { class: 'ef-fpcfg__pricing' });
    root.appendChild(pricing);

    const qtyLabel = el('label', { class: 'ef-fpcfg__quantity' });
    qtyLabel.appendChild(el('span', {}, 'Quantity'));
    const maxQuantity = root.dataset.productId === '7577427902546' ? 10 : 99;
    const qty = el('input', { type: 'number', min: 1, max: maxQuantity, step: 1, value: 1, 'aria-label': 'Quantity' });
    let sessionQuantityRestored = false;
    try { const savedQty = Number(sessionStorage.getItem(storageKey + ':quantity')); if (Number.isSafeInteger(savedQty) && savedQty >= 1 && savedQty <= maxQuantity) { qty.value = savedQty; sessionQuantityRestored = true; } } catch (_) {}
    if (!sessionQuantityRestored && savedDesign && Number.isSafeInteger(savedDesign.quantity) && savedDesign.quantity>=1 && savedDesign.quantity<=maxQuantity) qty.value=savedDesign.quantity;
    qtyLabel.appendChild(qty);
    root.appendChild(qtyLabel);
    const message = el('p', { class: 'ef-fpcfg__message', role: 'status', 'aria-live': 'polite' });
    root.appendChild(message);
    // Action buttons
    const actions = el('div', { class: 'ef-fpcfg__actions' });
    actions.appendChild(el('button', { type: 'button', class: 'ef-fpcfg__atc', 'data-action': 'atc' }));
    actions.appendChild(el('button', { type: 'button', class: 'ef-fpcfg__express', 'data-action': 'express' }, 'Express Checkout'));
    root.appendChild(actions);

    // ───────────────────────────────────────────────────────
    // Pricing logic — sum matched mapGroup map prices
    // ───────────────────────────────────────────────────────
    function calcPrice() { const result = engine.resolve(cfg, selections); return result.valid ? result.cents / 100 : null; }

    function getSel(qid) {
      const q = steps.flatMap(s => s.questions).find(x => x.id === qid);
      if (!q) return null;
      return (q.selections || []).find(s => s.id === selections[qid]) || null;
    }

    // Compute the price modifier for one selection in step i.
    // Strategy: temporarily set selections[qid] = candidateId, recompute price,
    // diff vs base lowest path. Cheap because only one calc per option.
    function priceForOption(stepIdx, candidateId) {
      const q = steps[stepIdx].questions[0];
      const qid = q.id;
      const prev = selections[qid];
      selections[qid] = candidateId;
      const newPrice = calcPrice();
      selections[qid] = prev;
      return newPrice;
    }

    function renderSelectedPreview(stepIdx) {
      const card = cards[stepIdx];
      const q = steps[stepIdx].questions[0];
      const qid = q.id;
      const sel = (q.selections || []).find(x => x.id === selections[qid]);
      const selBtn = $('.ef-fpcfg__cardselected', card);

      const imgHtml = sel ? optionImageHtml(sel) : '';
      const desc = sel ? (sel.description || descriptionFor(sel.label)) : null;
      try { if (sessionStorage.getItem(storageKey)) userPicked.add(stepIdx); } catch (_) {}
      const subText = desc || (userPicked.has(stepIdx) ? 'Selected' : 'Tap to choose');
      selBtn.innerHTML = `
        <span class="ef-fpcfg__selectedimg ${imgHtml ? '' : 'is-empty'}">${imgHtml}</span>
        <span class="ef-fpcfg__selectedinfo">
          <span class="ef-fpcfg__selectedlabel">${sel ? sel.label : 'Choose...'}</span>
          <span class="ef-fpcfg__selectedsub">${subText}</span>
        </span>
        <span class="ef-fpcfg__chev" aria-hidden="true">⌄</span>
      `;
    }

    function renderOptionsGrid(stepIdx) {
      const card = cards[stepIdx];
      const grid = $('.ef-fpcfg__optsgrid', card);
      const q = steps[stepIdx].questions[0];
      const qid = q.id;
      const sels = q.selections || [];

      // Compute price for each option (delta vs cheapest option in this step)
      const optPrices = sels.map(sel => priceForOption(stepIdx, sel.id));
      const validPrices = optPrices.filter(p => p != null);
      const minStepPrice = validPrices.length ? Math.min(...validPrices) : null;

      grid.innerHTML = sels.map((sel, idx) => {
        const img = optionImageHtml(sel);
        const selected = selections[qid] === sel.id ? 'is-selected' : '';
        const delta = optPrices[idx] == null ? null : optPrices[idx] - minStepPrice;
        const priceLbl = delta == null ? '<span class="ef-fpcfg__optprice">Select a compatible combination</span>' : delta > 0
          ? `<span class="ef-fpcfg__optprice">+${FMT_USD.format(delta)}</span>`
          : `<span class="ef-fpcfg__optprice ef-fpcfg__optprice--free">No price increase</span>`;
        return `<label class="ef-fpcfg__opt ${selected}" data-qid="${qid}" data-value="${sel.id}" data-step="${stepIdx}">
          <input type="radio" name="q-${qid}" value="${sel.id}" ${selected ? 'checked' : ''}>
          <span class="ef-fpcfg__optimg">${img}</span>
          <span class="ef-fpcfg__optlabel">${sel.label}</span>
          ${priceLbl}
        </label>`;
      }).join('');
    }

    function renderPricing() {
      const result = engine.resolve(cfg, selections);
      const quantity = Number(qty.value);
      const validQty = Number.isSafeInteger(quantity) && quantity >= 1 && quantity <= maxQuantity;
      pricing.replaceChildren();
      if (result.valid) {
        result.lines.forEach(line => {
          const row = el('div', {class: 'ef-fpcfg__priceline'});
          row.appendChild(el('span', {class:'ef-fpcfg__pricelabel'})); row.firstChild.textContent = line.title;
          row.appendChild(el('span', {class:'ef-fpcfg__priceval'}, FMT_USD.format(line.cents / 100)));
          pricing.appendChild(row);
          const skus = line.components.filter(c => c.sku).map(c => c.sku + (Number(c.quantity) > 1 ? ' × ' + c.quantity : '')).join(', ');
          if (skus) { const code = el('div', {class:'ef-fpcfg__ordercode'}); code.textContent = 'Order code: ' + skus; pricing.appendChild(code); }
        });
        const row = el('div', {class:'ef-fpcfg__priceline ef-fpcfg__priceline--total'});
        row.appendChild(el('span', {}, validQty ? 'Total · ' + quantity + (quantity === 1 ? ' item' : ' items') : 'Unit price'));
        row.appendChild(el('span', {class:'ef-fpcfg__priceval'}, FMT_USD.format(result.cents / 100 * (validQty ? quantity : 1))));
        pricing.appendChild(row);
      } else { pricing.textContent = 'Price unavailable for this combination. Change your selections or contact us for help.'; }
      if (!validQty) message.textContent = 'Enter a whole quantity from 1 to ' + maxQuantity + '.';
      else if (!busy) message.textContent = root.dataset.checkoutReady === 'false' ? 'Online purchase for this configuration is not available yet. Please contact us for help.' : '';
      $$('[data-action]', root).forEach(b => { b.disabled = busy || !result.valid || !validQty || root.dataset.checkoutReady === 'false'; });
      const atc = $('.ef-fpcfg__atc', root);
      atc.textContent = busy ? 'Adding…' : result.valid && validQty ? 'Order for ' + FMT_USD.format(result.cents / 100 * quantity) : 'Order your fire pit';
    }
    qty.addEventListener('input', () => { const n = Number(qty.value); if (Number.isSafeInteger(n) && n >= 1 && n <= maxQuantity) { try { sessionStorage.setItem(storageKey + ':quantity', String(n)); } catch (_) {} } renderPricing(); });
    qty.addEventListener('change', () => { configId = 'fp-' + (globalThis.crypto?.randomUUID?.() || Date.now()); renderPricing(); });

    function setOpen(idx) {
      openStep = idx;
      cards.forEach((c, i) => {
        c.classList.toggle('is-open', i === idx);
        c.classList.toggle('is-current', i === idx);
        const btn = $('.ef-fpcfg__cardselected', c);
        if (btn) btn.setAttribute('aria-expanded', i === idx ? 'true' : 'false');
      });
      // Re-render the now-open step's options (price deltas depend on other selections)
      if (idx >= 0 && idx < cards.length) renderOptionsGrid(idx);
    }

    function setSelection(stepIdx, value) {
      const q = steps[stepIdx].questions[0];
      if (busy) return;
      selections[q.id] = value;
      configId = 'fp-' + (globalThis.crypto?.randomUUID?.() || Date.now());
      try { sessionStorage.setItem(storageKey, JSON.stringify(selections)); } catch (_) {}
      userPicked.add(stepIdx);
      // Mark all preceding cards complete
      cards.forEach((c, i) => {
        c.classList.toggle('is-complete', userPicked.has(i));
      });
      // Update selected preview for this step
      renderSelectedPreview(stepIdx);
      renderPricing();
      // Doors-style navigation keeps the current choice visible until Next.
      if(root.classList.contains('ef-fpcfg--doors')) { setOpen(stepIdx); return; }
      // Auto-collapse this, open next (if any)
      const next = stepIdx + 1;
      if (next < cards.length) {
        setOpen(next);
      } else {
        setOpen(-1); // close all if last step
      }
    }

    // ──────────── Event delegation ────────────
    root.addEventListener('click', e => {
      // Selected preview button → toggle expand
      const selBtn = e.target.closest('.ef-fpcfg__cardselected');
      if (selBtn) {
        const card = selBtn.closest('.ef-fpcfg__card');
        const idx = parseInt(card.dataset.step, 10);
        setOpen(openStep === idx ? -1 : idx);
        return;
      }
      // Option pick
      const opt = e.target.closest('.ef-fpcfg__opt');
      if (opt) {
        if (e.target.tagName === 'INPUT') return;
        e.preventDefault();
        const stepIdx = parseInt(opt.dataset.step, 10);
        setSelection(stepIdx, opt.dataset.value);
        return;
      }
      // ATC / Express buttons
      const action = e.target.closest('[data-action]');
      if (action) {
        e.preventDefault();
        addToCart(action.dataset.action === 'express');
      }
    });

    root.addEventListener('change', e => { if (e.target.matches('.ef-fpcfg__opt input')) { const opt = e.target.closest('.ef-fpcfg__opt'); setSelection(Number(opt.dataset.step), e.target.value); } });

    async function addToCart(express) {
      if (busy || root.dataset.checkoutReady === 'false') return;
      let payload;
      try {
        payload = engine.payload(cfg, selections, Number(qty.value), {variantId:root.dataset.variantId, productTitle:root.dataset.productTitle, configId});
      } catch (error) { renderPricing(); message.textContent = error.message; return; }
      busy = true;
      qty.disabled = true;
      renderPricing();
      const workerUrl = window.EF_DRAFT_ORDER_WORKER_URL || 'https://ef-draft-order.danielzajacus.workers.dev';
      try {
        await window.EFPrepareCheckout(payload);
        const response = await fetch(workerUrl, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify(payload)});
        const data = await response.json();
        if (!response.ok || !data.invoice_url) throw new Error(data.message || 'Could not open checkout. Please contact us for help.');
        const destination = new URL(data.invoice_url);
        if (destination.protocol !== 'https:') throw new Error('Checkout could not be opened. Please contact us for help.');
        if (window.top !== window.self) window.open(destination.href, '_blank', 'noopener');
        else { window.location.assign(destination.href); return; }
        busy = false; qty.disabled = false; renderPricing();
        message.textContent = 'Checkout opened in a new tab.';
      } catch (error) {
        busy = false; qty.disabled = false; renderPricing();
        message.textContent = error.message || 'We could not confirm checkout. Your selections are saved. Please contact us before trying again.';
      }
    }

    // Initial render
    steps.forEach((_, i) => {
      renderSelectedPreview(i);
    });
    renderPricing();
    setOpen(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
